import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {ReservationNoteService} from './reservation-note.service';
import { ReservationNoteListComponent } from './reservation-note-list/reservation-note-list.component';
import { ReservationNoteAddComponent } from './reservation-note-add/reservation-note-add.component';
import {AgGridModule} from 'ag-grid-angular';
import {FormsModule} from '@angular/forms';
import {Trip2ThemeModule} from '../../../trip2-theme/trip2-theme.module';
import {DirectivesModule} from '../../../directives/directives.module';
import { GeofenceService } from 'app/pages/payors/components/geofence/geofence.service';
import { EmailsInputModule } from '../../../utils/emails-input/emails-input.module';
import {GridComplaintsResponsesModule} from 'app/utils/grid-complaints-responses/grid-complaints-responses.module';
import {NoteTemplateChipsModule} from '../../../utils/note-template-chips/note-template-chips.module';

@NgModule({
  imports: [
    CommonModule,
    AgGridModule.withComponents([]),
    FormsModule,
    Trip2ThemeModule,
    DirectivesModule,
    EmailsInputModule,
    GridComplaintsResponsesModule,
    NoteTemplateChipsModule
  ],
  declarations: [ReservationNoteListComponent, ReservationNoteAddComponent],
    exports: [ReservationNoteListComponent, ReservationNoteAddComponent],
    providers: [
        ReservationNoteService,
        GeofenceService
    ]
})
export class ReservationNotesModule { }



// WEBPACK FOOTER //
// ./src/app/pages/trip-reservations/reservation-notes/reservation-notes.module.ts